<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Loyal to the Sky</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="titlepage" id="d14e256">
<h1 id="d7e86918"><span class="small">Loyal to the Sky</span></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LoyaltotheSky.vue?12316c98